import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { ModalCustomOptions, OTP_ACTION } from '@app/models';
import { UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { BankAccount } from '@interfaces/app';
import { CurrencyPipe } from '@angular/common';

@Component({
   selector: 'mnf-user-withdraw',
   templateUrl: './user-withdraw.component.html',
   styleUrls: ['./user-withdraw.component.scss'],
   providers: [CurrencyPipe]
})
export class UserWithdrawComponent implements OnInit {
   balance: number;
   wdForm: FormGroup;
   totalAccounts: number;
   bankAccounts: BankAccount[];
   modalOTPConf = {
      header: 'Retiro de fondos',
      title: 'Verificación de retiro',
      message: `Ingresa el <span class="cl-primary-7">Token</span> que ha sido enviado ${this.userServ.otpMethod === 'sms' ? 'por SMS' : 'a tu correo electrónico'}`
   };

   constructor(
      private modal: MatDialogRef<UserWithdrawComponent>,
      private userServ: UserService,
      private modalServ: ModalService,
      private toastrServ: ToastrService,
      private currencyPipe: CurrencyPipe,
   ) { }

   ngOnInit(): void {
      this.wdForm = new FormGroup({
         bankAccount: new FormControl('', [Validators.required]),
         amount: new FormControl('', {
            updateOn: 'blur',
            validators: [Validators.required, Validators.min(0.01), Validators.max(this.balance), Validators.maxLength(18)]
         }),
      });

      this.userServ.getBankAccounts().subscribe(ba => {
         this.bankAccounts = ba;
         this.totalAccounts = ba.length;
         this.wdForm.controls.bankAccount.setValue(this.bankAccounts[0]);
      });
   }

   get control() {
      return this.wdForm.controls.amount;
   }

   changeAmount() {
      // const amount = (this.wdForm.value.amount as number).toFixed(2).replace(',', '');

      // if (this.wdForm.value.amount !== (this.wdForm.value.amount as number).toFixed(2).replace(',', ''))  {
      //    this.wdForm.controls.amount.setValue(amount, { emitEvent: false });
      // }
   }

   close() {
      this.modal.close();
   }

   formatCurrency(amount: number): string {
      return this.currencyPipe.transform(amount, 'MXN', 'symbol', '1.2-2') || '';
    }

   next() {
      if (this.wdForm.valid) {
         const amount = Number(this.wdForm.value.amount);
         const bankAccount: BankAccount = this.wdForm.value.bankAccount;

         const conf: ModalCustomOptions = {
            header: 'Retiro de fondos',
            title: '¿Seguro de continuar?',
            message: `Vas a retirar un monto total de <span class="cl-primary-7">${this.formatCurrency(amount)} MXN</span>
        desde tu cuenta Monific a la cuenta: <span class="cl-primary-7">**** ${bankAccount.clabe} - ${bankAccount.bankName}</span>`,
            buttonText: 'Aceptar',
            cancelText: 'Cancelar'
         };

         const m = this.modalServ.modalCustom(conf);

         m.beforeClosed().subscribe(accept => {
            if (accept) {
               this.openOTPModal(amount, bankAccount);
            } else {
               this.modalServ.openUserWithdraw(this.balance);
            }
         });
         this.modal.close();
      } else {
         const amount = this.wdForm.controls['amount'].value;
         if(amount > this.balance) {
            this.toastrServ.warning('El monto a retirar no puede ser mayor al saldo disponible');
         }
      }
   }

   /** Enviar OTP y abrir modal para ingreso de clave */
   private openOTPModal(amount: number, bankAccount: BankAccount) {
      this.modalServ.sendAndOpenModalOTP(OTP_ACTION.SPO, this.modalOTPConf).subscribe(otp => this.withdrawOption(otp, amount, bankAccount));
   }

   /** Opciones para respuesta de OTP */
   private withdrawOption(otp: string, amount: number, bankAccount: BankAccount) {
      if (otp) {
         // Si se ingresó 5 digitos del token sigue la comprobación del token para la operación
         this.withdraw(otp, amount, bankAccount);
      } else {
         // Se vuelve a abrir el modal de retiro
         this.modalServ.openUserWithdraw(this.balance);
      }
   }

   /** ACCIÓN PARA RETIRO DE USUARIO */
   private withdraw(otp: string, amount: number, bankAccount: BankAccount) {
      this.userServ.createSpoOut(otp, amount, bankAccount.id).subscribe({
         next: () => {
            this.modalServ.modalCustom({
               img: 'https://static.monific.com/assets/assets-app/img/icon/img/funds-success.svg',
               title: 'Retiro exitoso',
               message: `Retiro por <span class="cl-primary"><strong>$${amount} M.X.N</strong></span> de tu cuenta Monific a la cuenta <span class="cl-primary fw-sbold"><strong>****${bankAccount.clabe} - ${bankAccount.bankName}</strong></span>`,
               buttonText: 'Aceptar'
            });
         },
         error: err => {
            if (err.error?.err !== 'TS01') this.toastrServ.warning(err.error?.msg);

            // Se vuelve a abrir el modal de retiro
            this.modalServ.openModalOTP(this.modalOTPConf).subscribe(otp => this.withdrawOption(otp, amount, bankAccount));
         }
      });
   }

   addAll() {
      this.wdForm.controls['amount'].setValue(this.balance);
    }

}
